import { FC, useEffect } from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { AppProps } from 'next/app'
import Head from 'next/head'
import { appWithTranslation } from 'next-i18next'
import { Provider } from 'react-redux'
import { useStore } from 'store'
import nextI18NextConfig from '../../next-i18next.config.js'
import { startUp } from 'utils/startUp'
import 'slick-carousel/slick/slick.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'styles/globals.scss'

/**
 * Init Bugsnag
 * - if NODE_ENV is production
 * - if NEXT_PUBLIC_VERCEL_ENV is production (will be 'preview' on staging + preview deployments, we only want production)
 * - only client-side, skip server-side (as this file will also run on the server)
 */
if (
  process.env.NODE_ENV === 'production' && // DEBUG: comment out to test locally (development env)
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production' && // DEBUG: comment out to test staging
  typeof window !== 'undefined'
) {
  Bugsnag.start({
    apiKey: '9012beaa45bddf5a9fd09bd2af1b228c',
    plugins: [new BugsnagPluginReact()]
  })
}

const App: FC<AppProps> = ({ Component, pageProps }) => {
  // Store
  const store = useStore(pageProps.initialReduxState)

  /**
   * Triggered on first render
   * Executes the startUp function
   */
  useEffect(() => startUp(), [])

  return (
    <Provider store={store}>
      {/* Default SEO */}
      <Head>
        <link rel="icon" href="/favicon.ico" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta property="og:image" content="https://www.boltenergie.be/images/social.jpg" key="image" />
        <meta property="twitter:site" content="@boltenergie" />
        <meta property="twitter:card" content="summary_large_image" />
      </Head>

      {/* Page Component */}
      <Component {...pageProps} />

      {/* Modal parent */}
      <div id="modal-root" />
    </Provider>
  )
}

export default appWithTranslation(App, nextI18NextConfig)
